// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"ProlongationTable_messageCol__2FXdY","tableLoading":"ProlongationTable_tableLoading__1gkLk","table":"ProlongationTable_table__2PBdy"};